import { render, staticRenderFns } from "./SelectMultipleList.vue?vue&type=template&id=2d3a54bb"
import script from "./SelectMultipleList.vue?vue&type=script&lang=js"
export * from "./SelectMultipleList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports